<div class="flex containerInfoCard rounded {{ className }}">
  <div class="w-[8px] bg-primary_text rounded-s text-center flex items-center justify-center flex-shrink-0"></div>
  <div class="flex items-center justify-center">
    <div class="w-[65px] flex items-center justify-center pl-2">
      <div class="iconInfoCard text-center"></div>
    </div>

    <div class="flex-grow items-center justify-center p-3">
      <div class="titleInfoCard">
        {{ title }}
      </div>
      <div class="textInfoCard mt-2">
        {{ message }}
      </div>
    </div>
  </div>
</div>
